<script setup>
import {computed, inject, onMounted, reactive, ref} from "vue";
import trackersService from "@/services/trackers.service";
import PrimaryButton from "@/components/ui/PrimaryButton.vue";
import RecipientsListEdit from "@/components/notes/RecipientsListEdit.vue";
import {Mentionable} from "vue-mention";
import Avatar from "@/components/ui/Avatar.vue";
import {getNoun} from "../../../helpers/string";
import teamService from "@/services/team.service";

const emit = defineEmits(['saved'])

const trackerId = inject('tracker').value.id;

const form = reactive({
    text: "",
    recipients: [],
});

const loading = ref(false);
const showModal = ref(false);
const recipientsList = ref([]);
const usersMentionList = ref([]);
const recipientsListEditModal = ref(null);

const canSave = computed(() => !loading.value && form.text.length);

onMounted(() => {
    getUsersMentionList();
});

async function getRecipientsList() {
    const {data} = await trackersService.getMessageRecipientsList(trackerId);

    recipientsList.value = data;
    form.recipients = data.map(user => user.id);
}

async function getUsersMentionList() {
    const {data} = await teamService.getUsersMentionList();
    usersMentionList.value = data;
}

function applyMention(item) {
    if (!recipientsList.value.find(user => user.id === item.id)) {
        recipientsList.value.push(item);
    }
}

async function save() {
    loading.value = true;
    await trackersService.addNote(trackerId, form);

    emit('saved');
    loading.value = false;
    showModal.value = false;
}

function setRecipients(recipients) {
    form.recipients = recipients;
}

function show() {
    form.text = '';
    showModal.value = true;
    getRecipientsList();
}

defineExpose({show});
</script>

<template>
    <div>
        <b-modal v-model="showModal" title="Add A Note" hide-footer modal-class="modal-add-note">
            <Mentionable
                :keys="['@']"
                :items="usersMentionList"
                offset="6"
                insert-space
                placement="top-start"
                @apply="applyMention"
            >
                <template #item-@="{ item }">
                    <div class="user">
                        <Avatar
                            :username="item.name"
                            :src="item.avatar"
                            :size="25"
                        />

                        <div class="mention-item__inner">
                            {{ item.value }}
                            <span class="dim">
                                ({{ item.name }})
                            </span>
                        </div>
                    </div>
                </template>

                <textarea
                    v-model="form.text"
                    class="form-control"
                    placeholder="Add A Note"
                />
            </Mentionable>

            <footer class="modal-footer">
                <p class="modal-text d-flex">{{form.recipients.length}} {{getNoun('user', form.recipients.length)}} will be notified
                    <a @click="recipientsListEditModal.open()" class="link-edit ml-2"></a>
                </p>

                <PrimaryButton
                    caption="Post"
                    loading-caption="Saving..."
                    :loading="loading"
                    :disabled="!canSave"
                    class="button"
                    @click="save"
                />
            </footer>
        </b-modal>

        <RecipientsListEdit
            ref="recipientsListEditModal"
            :message-recipients-list="recipientsList"
            @setRecipients="setRecipients"
            @opened="showModal = false"
            @closed="showModal = true"
        />
    </div>
</template>

<style scoped>

</style>
